/**
 * KI-Tageslimit für die kostenlose Version.
 *
 * Die KI-Erfassung (Foto → Gemini/ML) ist für alle Nutzer nutzbar, aber ohne Abo
 * auf FREE_KI_DAILY_LIMIT Scans pro Tag begrenzt — sonst tragen wir die Gemini-Kosten
 * unbegrenzt für Nicht-Abonnenten. Premium = unbegrenzt.
 *
 * Der Zähler liegt bewusst nur lokal (localStorage) und pro GERÄT: Es ist eine
 * Kosten-/Fairness-Bremse, kein hartes Sicherheits-Gate. Die Tagesgrenze richtet sich
 * nach der LOKALEN Zeit (Ladenschluss ist lokal, nicht UTC).
 */
export const FREE_KI_DAILY_LIMIT = 20;

const PREFIX = 'ki_scans_';

function todayKey() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${PREFIX}${y}-${m}-${day}`;
}

/** Anzahl der heute bereits verbrauchten KI-Scans (0 bei Neuinstallation/neuem Tag). */
export function getKiScansToday() {
  try {
    return parseInt(localStorage.getItem(todayKey()) || '0', 10) || 0;
  } catch {
    return 0;
  }
}

/**
 * Darf jetzt ein KI-Scan laufen?
 * @param {boolean} isPremium
 * @returns {{ allowed: boolean, remaining: number, used: number, limit: number }}
 */
export function kiScanAllowed(isPremium) {
  if (isPremium) {
    return { allowed: true, remaining: Infinity, used: 0, limit: Infinity };
  }
  const used = getKiScansToday();
  return {
    allowed: used < FREE_KI_DAILY_LIMIT,
    remaining: Math.max(0, FREE_KI_DAILY_LIMIT - used),
    used,
    limit: FREE_KI_DAILY_LIMIT,
  };
}

/**
 * Einen verbrauchten KI-Scan verbuchen (nur für Free-Nutzer relevant, aber immer
 * gezählt — der Zähler wird nur bei Free-Nutzern ausgewertet). Räumt dabei alte
 * Tages-Keys auf, damit sich localStorage nicht zumüllt.
 * @returns {number} neuer Tageszähler
 */
export function noteKiScanUsed() {
  try {
    const key = todayKey();
    const next = (parseInt(localStorage.getItem(key) || '0', 10) || 0) + 1;
    localStorage.setItem(key, String(next));
    cleanupOldKeys(key);
    return next;
  } catch {
    return 0;
  }
}

function cleanupOldKeys(currentKey) {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && key.startsWith(PREFIX) && key !== currentKey) {
        localStorage.removeItem(key);
      }
    }
  } catch {
    /* localStorage nicht verfügbar — egal */
  }
}
